/* =============================================================
   Luxe Sateen Bamboo — landing interactivity
   - Variant matching (color / size / bundle → variant id)
   - Live price + Afterpay + CTA update
   - Thumbnail gallery swap
   - Sticky bar visibility on scroll
   ============================================================= */
(function () {
  "use strict";

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));

  // ---- Money formatting (Shopify-style, falls back to USD) ----
  function formatMoneyCents(cents) {
    const dollars = (cents / 100).toFixed(2);
    return "$" + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // ---- Init buy box ----
  const form = $("#bcl-product-form");
  if (!form) return;

  const productJsonEl = $("[data-bcl-product-json]", form);
  let product = null;
  try {
    product = JSON.parse(productJsonEl.textContent);
  } catch (e) {}
  if (!product) return;

  const variantIdInput = form.querySelector("[data-bcl-variant-id]");
  const currentId = variantIdInput ? String(variantIdInput.value) : "";
  const currentVariant =
    product.variants.find((v) => String(v.id) === currentId) ||
    product.variants[0];
  const selected =
    currentVariant && currentVariant.options
      ? currentVariant.options.slice()
      : [];

  let meta = { sizeIdx: -1, colorIdx: -1, bundleIdx: -1, bestsellerHandle: "" };
  const metaEl = form.querySelector("script[data-bcl-option-meta]");
  if (metaEl) {
    try {
      meta = Object.assign(meta, JSON.parse(metaEl.textContent));
    } catch (e) {}
  }

  let productTags = [];
  const tagsEl = form.querySelector("script[data-bcl-product-tags]");
  if (tagsEl) {
    try {
      productTags = JSON.parse(tagsEl.textContent);
      if (!Array.isArray(productTags)) productTags = [];
    } catch (e) {
      productTags = [];
    }
  }

  const tagPicker = form.querySelector("[data-bcl-tag-bundle-picker]");
  if (tagPicker) {
    tagPicker.addEventListener(
      "mousedown",
      function (e) {
        tagPicker
          .querySelectorAll(".bcl-bundle--tag-tier")
          .forEach(function (l) {
            delete l.dataset.bclWillToggleOptOut;
          });
        const lbl = e.target.closest(
          ".bcl-bundle--tag-tier:not([data-bcl-tag-tier-opt-out])",
        );
        if (!lbl) return;
        const inp = lbl.querySelector('input[name="bcl-tag-bundle-tier"]');
        if (inp && inp.checked) {
          lbl.dataset.bclWillToggleOptOut = "1";
        }
      },
      true,
    );
  }

  /** Mirrors `productFunctions.liquid` — `bundle:default:` only, scoped SKU prefix or global tier list. */
  function bclStripBundleTypePayload(tag, type) {
    const re = new RegExp("^bundle:" + type + ":(.+)$", "i");
    const m = String(tag || "").match(re);
    return m ? m[1].trim() : "";
  }

  const __BCL_TIER_ONLY_INLINE = /^\d+-\d+(\|\d+-\d+)*$/;

  function parseBundleTagPayloadAfterPrefixBm(payload) {
    const p = String(payload || "").trim();
    if (!p) return null;
    if (__BCL_TIER_ONLY_INLINE.test(p)) return { key: null, tiers: p };
    const m = p.match(/^(.+?):(\d+-\d+(\|\d+-\d+)*)$/);
    if (m) return { key: m[1].trim(), tiers: m[2] };
    return null;
  }

  function pickLongestSkuKeyMatchBm(variantSku, keys) {
    const s = String(variantSku || "")
      .trim()
      .toUpperCase();
    if (!s || !keys.length) return null;
    const uniq = [];
    keys.forEach(function (k) {
      const t = String(k || "").trim();
      if (!t || uniq.indexOf(t) !== -1) return;
      uniq.push(t);
    });
    uniq.sort(function (a, b) {
      return b.length - a.length;
    });
    for (let i = 0; i < uniq.length; i++) {
      const ku = uniq[i].toUpperCase();
      if (s.indexOf(ku) === 0) return uniq[i];
    }
    return null;
  }

  function collectDefaultBundleTierStringFromTags(productTagsList, variantSku) {
    const type = "default";
    const bestByQty = new Map();
    function addSegment(seg) {
      const s = String(seg || "").trim();
      if (!s) return;
      const dash = s.lastIndexOf("-");
      if (dash <= 0) return;
      const qty = parseInt(s.slice(0, dash), 10);
      const price = parseFloat(s.slice(dash + 1));
      if (isNaN(qty) || isNaN(price)) return;
      const prev = bestByQty.get(qty);
      if (!prev || price < prev.price) {
        bestByQty.set(qty, { qty: qty, price: price });
      }
    }
    const entries = [];
    productTagsList.forEach(function (tag) {
      const pl = bclStripBundleTypePayload(tag, type);
      const parsed = parseBundleTagPayloadAfterPrefixBm(pl);
      if (!parsed || !parsed.tiers) return;
      entries.push(parsed);
    });
    const hasScoped = entries.some(function (e) {
      return !!e.key;
    });
    let matchKey = null;
    if (hasScoped) {
      matchKey = pickLongestSkuKeyMatchBm(
        variantSku,
        entries
          .filter(function (e) {
            return !!e.key;
          })
          .map(function (e) {
            return e.key;
          }),
      );
    }
    entries.forEach(function (parsed) {
      if (hasScoped) {
        if (!parsed.key) return;
        if (
          !matchKey ||
          String(parsed.key).trim().toUpperCase() !==
            String(matchKey).trim().toUpperCase()
        )
          return;
      } else if (parsed.key) {
        return;
      }
      parsed.tiers.split("|").forEach(addSegment);
    });
    return Array.from(bestByQty.values())
      .sort(function (a, b) {
        return a.qty - b.qty;
      })
      .map(function (p) {
        return p.qty + "-" + p.price;
      })
      .join("|");
  }

  function updateTagPickerTierCardsForString(tierStr) {
    if (!tagPicker) return;
    if (!tierStr) {
      tagPicker
        .querySelectorAll(".bcl-bundle--tag-tier")
        .forEach(function (label) {
          if (label.hasAttribute("data-bcl-tag-tier-opt-out")) return;
          label.dataset.tierTotal = "";
        });
      const opt = tagPicker.querySelector(
        'input[name="bcl-tag-bundle-tier"][value="opt-out"]',
      );
      if (opt) opt.checked = true;
      return;
    }
    const byQty = {};
    tierStr.split("|").forEach(function (seg) {
      const s = String(seg).trim();
      const dash = s.lastIndexOf("-");
      if (dash <= 0) return;
      const qty = parseInt(s.slice(0, dash), 10);
      const price = parseFloat(s.slice(dash + 1));
      if (isNaN(qty) || isNaN(price)) return;
      byQty[qty] = price;
    });
    tagPicker
      .querySelectorAll(".bcl-bundle--tag-tier")
      .forEach(function (label) {
        if (label.hasAttribute("data-bcl-tag-tier-opt-out")) return;
        const u = parseInt(
          label.getAttribute("data-tier-units") ||
            label.dataset.tierUnits ||
            "0",
          10,
        );
        if (!u || byQty[u] == null) return;
        label.dataset.tierTotal = String(byQty[u]);
      });
  }

  function parseTierTotalCentsFromLabel(label) {
    if (!label || !label.dataset) return null;
    const raw = label.dataset.tierTotal;
    const n = parseFloat(String(raw || "").replace(/,/g, ""));
    if (isNaN(n) || n <= 0) return null;
    return Math.round(n * 100);
  }

  function ensureTagTierRadioChecked() {
    if (!tagPicker) return;
    if (tagPicker.querySelector('input[name="bcl-tag-bundle-tier"]:checked'))
      return;
    const optOut = tagPicker.querySelector(
      'input[name="bcl-tag-bundle-tier"][value="opt-out"]',
    );
    const first = tagPicker.querySelector('input[name="bcl-tag-bundle-tier"]');
    if (optOut) optOut.checked = true;
    else if (first) first.checked = true;
  }

  function getTagTierContext(v) {
    if (!tagPicker || !v) return null;
    ensureTagTierRadioChecked();
    const radio = tagPicker.querySelector(
      'input[name="bcl-tag-bundle-tier"]:checked',
    );
    if (!radio || radio.value === "opt-out") return null;
    const label = radio.closest(".bcl-bundle--tag-tier");
    if (!label || label.hasAttribute("data-bcl-tag-tier-opt-out")) return null;
    const units = parseInt(radio.value, 10) || 1;
    const tierTotalCents = parseTierTotalCentsFromLabel(label);
    if (tierTotalCents == null) return null;
    const unitCmp =
      v.compare_at_price && v.compare_at_price > v.price
        ? v.compare_at_price
        : v.price;
    const lineCmpCents = Math.round(unitCmp * units);
    return { units, tierTotalCents, lineCmpCents };
  }

  function updateTagTierRowLabels(v) {
    if (!tagPicker || !v) return;
    const unitCmp =
      v.compare_at_price && v.compare_at_price > v.price
        ? v.compare_at_price
        : v.price;
    const optLbl = tagPicker.querySelector("[data-bcl-tag-tier-opt-out]");
    if (optLbl) {
      const nowEl = optLbl.querySelector("[data-bcl-tag-tier-now]");
      const wasEl = optLbl.querySelector("[data-bcl-tag-tier-was]");
      if (nowEl) nowEl.textContent = formatMoneyCents(v.price);
      if (wasEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          wasEl.textContent = formatMoneyCents(v.compare_at_price);
          wasEl.style.display = "";
        } else {
          wasEl.textContent = "";
          wasEl.style.display = "none";
        }
      }
    }
    tagPicker
      .querySelectorAll(".bcl-bundle--tag-tier")
      .forEach(function (label) {
        if (label.hasAttribute("data-bcl-tag-tier-opt-out")) return;
        const tierCents = parseTierTotalCentsFromLabel(label);
        const units = parseInt(label.dataset.tierUnits || "1", 10) || 1;
        if (tierCents == null) return;
        const each = Math.round(tierCents / units);
        const heading = label.querySelector("[data-bcl-tag-tier-heading]");
        if (heading) {
          heading.innerHTML =
            "<strong>" +
            units +
            " " +
            (units === 1 ? "Set" : "Sets") +
            '</strong><span class="bcl-bundle-title-muted"> · ' +
            formatMoneyCents(each) +
            "/set</span>";
        }
        const nowEl = label.querySelector("[data-bcl-tag-tier-now]");
        const wasEl = label.querySelector("[data-bcl-tag-tier-was]");
        if (nowEl) nowEl.textContent = formatMoneyCents(tierCents);
        if (wasEl) {
          const lineCmp = Math.round(unitCmp * units);
          if (lineCmp > tierCents) {
            wasEl.textContent = formatMoneyCents(lineCmp);
            wasEl.style.display = "";
          } else {
            wasEl.textContent = "";
            wasEl.style.display = "none";
          }
        }
      });
  }

  function handleizeSize(val) {
    return String(val || "")
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
  }

  // helper: get all option groups with their selectors
  function readSelections() {
    const opts = selected.slice();
    $$("[data-bcl-option-index]", form).forEach((el) => {
      const idx = parseInt(el.dataset.bclOptionIndex, 10);
      if (el.tagName === "SELECT") {
        opts[idx] = el.value;
      } else if (el.type === "radio" && el.checked) {
        opts[idx] = el.value;
      }
    });
    return opts;
  }

  function findVariant(opts) {
    return product.variants.find((v) => {
      return v.options.every((o, i) => o === opts[i]);
    });
  }

  function mediaVariantIds(m) {
    return m.variant_ids || m.variantIds || [];
  }

  function variantUsesMedia(v, m) {
    const ids = mediaVariantIds(m);
    const vid = Number(v.id);
    return ids.indexOf(v.id) !== -1 || ids.indexOf(vid) !== -1;
  }

  /** Resolve hero image URL for a variant (featured_image, featured_media, media.variant_ids, alt match). */
  function getVariantGallerySrc(v, opts) {
    if (!v) return "";
    if (v.featured_image && v.featured_image.src) return v.featured_image.src;
    if (
      v.featured_media &&
      v.featured_media.preview_image &&
      v.featured_media.preview_image.src
    ) {
      return v.featured_media.preview_image.src;
    }
    if (v.image && typeof v.image === "object" && v.image.src)
      return v.image.src;

    const medias = product.media || [];
    for (let i = 0; i < medias.length; i++) {
      if (variantUsesMedia(v, medias[i])) {
        const m = medias[i];
        if (m.preview_image && m.preview_image.src) return m.preview_image.src;
        if (m.src) return m.src;
      }
    }

    if (opts && meta.colorIdx >= 0) {
      const colorName = String(opts[meta.colorIdx] || "")
        .toLowerCase()
        .trim();
      if (colorName) {
        for (let j = 0; j < medias.length; j++) {
          const m = medias[j];
          if (m.media_type && m.media_type !== "image") continue;
          const alt = String(
            m.alt || (m.preview_image && m.preview_image.alt) || "",
          ).toLowerCase();
          if (
            alt.indexOf(colorName) !== -1 &&
            m.preview_image &&
            m.preview_image.src
          ) {
            return m.preview_image.src;
          }
        }
      }
    }

    return "";
  }

  function updateGalleryForVariant(v, opts) {
    const hero = form.closest(".bcl-hero");
    if (!hero || !v) return;
    const src = getVariantGallerySrc(v, opts);
    if (!src) return;

    const mainImg = hero.querySelector(".bcl-main-img");
    if (mainImg && mainImg.tagName === "IMG") {
      mainImg.removeAttribute("srcset");
      mainImg.src = src;
    }

    const medias = product.media || [];
    let activeIdx = -1;
    for (let i = 0; i < medias.length; i++) {
      if (variantUsesMedia(v, medias[i])) {
        activeIdx = i;
        break;
      }
    }
    if (activeIdx < 0 && v.featured_image && v.featured_image.id) {
      const fid = v.featured_image.id;
      activeIdx = medias.findIndex(function (m) {
        return (
          m.id === fid ||
          (m.preview_image && m.preview_image.id === fid) ||
          (m.preview_image &&
            v.featured_image.src &&
            m.preview_image.src.split("?")[0] ===
              v.featured_image.src.split("?")[0])
        );
      });
    }
    if (activeIdx < 0 && opts && meta.colorIdx >= 0) {
      const colorName = String(opts[meta.colorIdx] || "")
        .toLowerCase()
        .trim();
      if (colorName) {
        for (let j = 0; j < medias.length; j++) {
          const m = medias[j];
          if (m.media_type && m.media_type !== "image") continue;
          const alt = String(
            m.alt || (m.preview_image && m.preview_image.alt) || "",
          ).toLowerCase();
          if (alt.indexOf(colorName) !== -1) {
            activeIdx = j;
            break;
          }
        }
      }
    }

    const thumbs = hero.querySelectorAll("[data-bcl-thumb]");
    if (activeIdx >= 0 && thumbs[activeIdx]) {
      thumbs.forEach(function (t) {
        t.classList.remove("is-active");
      });
      thumbs[activeIdx].classList.add("is-active");
    }
  }

  function updateSizeBubblePrices() {
    const opts = readSelections();
    $$(".bcl-size-price", form).forEach((el) => {
      const sizeVal = el.getAttribute("data-bcl-size-value");
      if (!sizeVal) return;
      const match = product.variants.find((vv) => {
        if (meta.sizeIdx >= 0 && vv.options[meta.sizeIdx] !== sizeVal)
          return false;
        if (
          meta.colorIdx >= 0 &&
          vv.options[meta.colorIdx] !== opts[meta.colorIdx]
        )
          return false;
        if (
          meta.bundleIdx >= 0 &&
          vv.options[meta.bundleIdx] !== opts[meta.bundleIdx]
        )
          return false;
        return true;
      });
      el.textContent = match ? formatMoneyCents(match.price) : "—";
    });
  }

  function bundleUnitsFromLabel(val, dataUnitsAttr) {
    const u = parseInt(dataUnitsAttr, 10);
    if (!isNaN(u) && u >= 1 && u <= 48) return u;
    const m = String(val || "").match(/(\d+)/);
    if (m) {
      const n = parseInt(m[1], 10);
      if (!isNaN(n) && n >= 1 && n <= 48) return n;
    }
    const low = String(val || "").toLowerCase();
    if (low.includes("triple")) return 3;
    if (low.includes("double") || low.includes("duo")) return 2;
    return 1;
  }

  function updateBundleRowPrices() {
    const opts = readSelections();
    $$(".bcl-bundle[data-bcl-bundle-value]", form).forEach((lab) => {
      const bundleVal = lab.getAttribute("data-bcl-bundle-value");
      const nowEl = lab.querySelector(".bcl-bundle-price-now");
      const wasEl = lab.querySelector(".bcl-bundle-price-was");
      const headingEl = lab.querySelector("[data-bcl-bundle-heading]");
      if (!bundleVal || !nowEl) return;
      const match = product.variants.find((vv) => {
        if (meta.bundleIdx >= 0 && vv.options[meta.bundleIdx] !== bundleVal)
          return false;
        if (
          meta.sizeIdx >= 0 &&
          vv.options[meta.sizeIdx] !== opts[meta.sizeIdx]
        )
          return false;
        if (
          meta.colorIdx >= 0 &&
          vv.options[meta.colorIdx] !== opts[meta.colorIdx]
        )
          return false;
        return true;
      });
      if (match) {
        nowEl.textContent = formatMoneyCents(match.price);
        if (wasEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            wasEl.textContent = formatMoneyCents(match.compare_at_price);
            wasEl.style.display = "";
          } else {
            wasEl.textContent = "";
            wasEl.style.display = "none";
          }
        }
        if (headingEl) {
          const units = bundleUnitsFromLabel(
            bundleVal,
            lab.getAttribute("data-bcl-bundle-units"),
          );
          const each = Math.round(match.price / units);
          headingEl.innerHTML =
            "<strong>" +
            units +
            " " +
            (units === 1 ? "Set" : "Sets") +
            '</strong><span class="bcl-bundle-title-muted"> · ' +
            formatMoneyCents(each) +
            "/set</span>";
        }
      }
    });
  }

  function updateBestsellerRibbon() {
    const h = (meta.bestsellerHandle || "").toLowerCase();
    if (!h) return;
    $$(".bcl-size", form).forEach((lab) => {
      const inp = lab.querySelector("input[type=radio]");
      const val = inp ? inp.value : "";
      lab.classList.toggle("is-bestseller", handleizeSize(val) === h);
    });
  }

  function updateVariant() {
    const opts = readSelections();
    const v = findVariant(opts);
    if (!v) return;

    if (tagPicker && productTags.length) {
      const tierStr = collectDefaultBundleTierStringFromTags(
        productTags,
        v.sku || "",
      );
      updateTagPickerTierCardsForString(tierStr);
    }

    const tagCtx = getTagTierContext(v);
    const qInput = form.querySelector("[data-bcl-quantity]");
    if (tagCtx && qInput) {
      qInput.value = String(tagCtx.units);
    } else if (tagPicker && qInput) {
      qInput.value = "1";
    }

    if (variantIdInput) {
      variantIdInput.value = v.id;
      variantIdInput.setAttribute("data-item-price", formatMoneyCents(v.price));
      if (v.compare_at_price && v.compare_at_price > v.price) {
        variantIdInput.setAttribute(
          "data-item-compare-at-price",
          formatMoneyCents(v.compare_at_price),
        );
      } else {
        variantIdInput.removeAttribute("data-item-compare-at-price");
      }
    }

    const priceEl = $("[data-bcl-price]", form);
    const compareEl = $("[data-bcl-compare]", form);
    const saveEl = $("[data-bcl-save]", form);
    const afterpayEl = $("[data-bcl-afterpay]", form);
    const ctaPriceEl = $("[data-bcl-cta-price]", form);

    // Repaint every row (single/opt-out price + all bundle tier totals) for the
    // newly selected variant. Must run even when the single "1 Set" option is
    // selected (tagCtx is null then), otherwise changing size leaves stale
    // prices in the buy box. Tier totals were just refreshed above via
    // updateTagPickerTierCardsForString.
    if (tagPicker) {
      updateTagTierRowLabels(v);
    }

    // Hero price (below reviews): always per-set unit price, not bundle tier total
    const unitPriceCents = v.price;
    const unitCompareCents =
      v.compare_at_price && v.compare_at_price > v.price
        ? v.compare_at_price
        : null;

    if (priceEl) priceEl.textContent = formatMoneyCents(unitPriceCents);
    if (afterpayEl)
      afterpayEl.textContent = formatMoneyCents(Math.round(unitPriceCents / 4));
    const anchorNowEl = $("[data-bcl-anchor-now]", form);
    if (anchorNowEl) anchorNowEl.textContent = formatMoneyCents(unitPriceCents);

    if (unitCompareCents && unitCompareCents > unitPriceCents) {
      if (compareEl) {
        compareEl.textContent = formatMoneyCents(unitCompareCents);
        compareEl.style.display = "";
      }
      if (saveEl) {
        const pct = Math.round((1 - unitPriceCents / unitCompareCents) * 100);
        saveEl.textContent = "Save " + pct + "%";
        saveEl.style.display = "";
      }
    } else {
      if (compareEl) compareEl.style.display = "none";
      if (saveEl) saveEl.style.display = "none";
    }

    // CTA / sticky: amount charged when adding (bundle tier total when a pack is selected)
    let checkoutPriceCents = unitPriceCents;
    if (tagCtx) {
      checkoutPriceCents = tagCtx.tierTotalCents;
    }
    if (ctaPriceEl)
      ctaPriceEl.textContent = formatMoneyCents(checkoutPriceCents);

    const submit = $("[data-bcl-submit]", form);
    const submitLabel = $("[data-bcl-submit-label]", form);
    if (submit) submit.disabled = !v.available;
    if (submitLabel)
      submitLabel.textContent = v.available ? "Add to Cart" : "Sold Out";

    const sbPrice = $("[data-bcl-sb-price]");
    if (sbPrice) sbPrice.textContent = formatMoneyCents(unitPriceCents);

    updateComparisonPricing(v);

    const colorLbl = $("[data-bcl-color-label]", form);
    const sizeLbl = $("[data-bcl-size-label]", form);
    // "Showing X" caption overlaid on the gallery image (lives outside the form).
    const galleryColor = document.querySelector("[data-bcl-gallery-color]");
    product.options.forEach((name, i) => {
      const nm = (name || "").toLowerCase();
      if (
        nm.indexOf("color") > -1 ||
        nm.indexOf("colour") > -1 ||
        nm.indexOf("shade") > -1
      ) {
        if (colorLbl) colorLbl.textContent = opts[i];
        if (galleryColor) galleryColor.textContent = opts[i];
      }
      if (nm.indexOf("size") > -1 && sizeLbl) sizeLbl.textContent = opts[i];
    });

    ["bcl-color", "bcl-size", "bcl-bundle"].forEach((cls) => {
      $$("." + cls, form).forEach((el) => {
        const input = el.querySelector("input[type=radio]");
        if (input) el.classList.toggle("is-selected", input.checked);
      });
    });

    updateSizeBubblePrices();
    updateBundleRowPrices();
    updateBestsellerRibbon();

    if (typeof jQuery !== "undefined") {
      jQuery(document).trigger("bcl:variant-changed");
    }

    updateGalleryForVariant(v, opts);

    const scarcityColor = form.querySelector("[data-bcl-scarcity-color]");
    if (scarcityColor && meta.colorIdx >= 0 && opts[meta.colorIdx]) {
      scarcityColor.textContent = opts[meta.colorIdx];
    }
  }

  function tickBclUrgencyClock() {
    const el = document.querySelector("[data-bcl-urgency-clock]");
    if (!el) return;
    const now = new Date();
    const end = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59,
      999,
    );
    let ms = end - now;
    if (ms < 0) ms = 0;
    const h = Math.floor(ms / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    const s = Math.floor((ms % 60000) / 1000);
    const pad = function (n) {
      return n < 10 ? "0" + n : String(n);
    };
    el.textContent = pad(h) + ":" + pad(m) + ":" + pad(s);
  }

  setInterval(tickBclUrgencyClock, 1000);
  tickBclUrgencyClock();

  // ---- Availability / sale / URL helpers (size + color) ----
  function optAt(v, idx) {
    if (idx < 0 || !v || !v.options) return null;
    return v.options[idx];
  }

  function variantForSizeColor(sizeVal, colorVal) {
    return product.variants.find(function (v) {
      if (meta.sizeIdx >= 0 && optAt(v, meta.sizeIdx) !== sizeVal) return false;
      if (meta.colorIdx >= 0 && optAt(v, meta.colorIdx) !== colorVal)
        return false;
      return true;
    });
  }

  // "available" already covers preorder (continue-selling) variants in Shopify's variant JSON.
  function sizeHasAvailable(sizeVal) {
    if (meta.sizeIdx < 0) return true;
    return product.variants.some(function (v) {
      return optAt(v, meta.sizeIdx) === sizeVal && v.available;
    });
  }

  function firstAvailableColorForSize(sizeVal) {
    const radios = $$(".bcl-color input[type=radio]", form);
    for (let i = 0; i < radios.length; i++) {
      const v = variantForSizeColor(sizeVal, radios[i].value);
      if (v && v.available) return radios[i].value;
    }
    return null;
  }

  function checkRadioByValue(groupSelector, value, handleized) {
    if (value == null) return null;
    const radios = $$(groupSelector + " input[type=radio]", form);
    for (let i = 0; i < radios.length; i++) {
      const rv = radios[i].value;
      const isMatch = handleized
        ? handleizeSize(rv) === handleizeSize(value)
        : rv === value;
      if (isMatch) {
        radios.forEach(function (r) {
          r.checked = false;
        });
        radios[i].checked = true;
        return rv;
      }
    }
    return null;
  }

  // If the selected color isn't available for the current size, jump to the first
  // available color for that size (per spec). If none, leave as-is (size is sold out).
  function ensureValidColorForCurrentSize() {
    if (meta.sizeIdx < 0 || meta.colorIdx < 0) return;
    const opts = readSelections();
    const sizeVal = opts[meta.sizeIdx];
    const cur = variantForSizeColor(sizeVal, opts[meta.colorIdx]);
    if (cur && cur.available) return;
    const fb = firstAvailableColorForSize(sizeVal);
    if (fb) checkRadioByValue(".bcl-color", fb);
  }

  // Show only colors that are in stock / preorder-available for the current size;
  // hide the rest. Stamp a sale tag on colors whose price is dropped below compare-at.
  function refreshColorAvailability() {
    if (meta.colorIdx < 0) return;
    const opts = readSelections();
    const sizeVal = meta.sizeIdx >= 0 ? opts[meta.sizeIdx] : null;

    // Baseline = highest price among available colors for this size. A color is
    // "on sale" only when it's cheaper than its same-size siblings (not vs compare-at).
    let baseline = 0;
    $$(".bcl-color", form).forEach(function (label) {
      const inp = label.querySelector("input[type=radio]");
      if (!inp) return;
      const v = variantForSizeColor(sizeVal, inp.value);
      if (v && v.available && v.price > baseline) baseline = v.price;
    });

    $$(".bcl-color", form).forEach(function (label) {
      const inp = label.querySelector("input[type=radio]");
      if (!inp) return;
      const v = variantForSizeColor(sizeVal, inp.value);
      const show = !!(v && v.available);
      label.style.display = show ? "" : "none";
      const badge = label.querySelector("[data-bcl-color-sale]");
      let pct = 0;
      if (show && baseline > 0 && v.price < baseline) {
        pct = Math.round((1 - v.price / baseline) * 100);
      }
      if (show && pct > 0) {
        if (badge) {
          badge.textContent = "-" + pct + "%";
          badge.style.display = "";
        }
        label.classList.add("has-sale");
      } else {
        if (badge) {
          badge.textContent = "";
          badge.style.display = "none";
        }
        label.classList.remove("has-sale");
      }
    });
  }

  // Gray + strike sizes whose every color is unavailable.
  function refreshSizeAvailability() {
    if (meta.sizeIdx < 0) return;
    $$(".bcl-size", form).forEach(function (label) {
      const inp = label.querySelector("input[type=radio]");
      if (!inp) return;
      label.classList.toggle("is-soldout", !sizeHasAvailable(inp.value));
    });
  }

  // Keep the URL shareable/reloadable: reflect the resolved variant id.
  function syncUrlToSelection() {
    const v = findVariant(readSelections());
    if (!v) return;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", String(v.id));
      window.history.replaceState({}, "", url.toString());
    } catch (e) {}
  }

  // Bundle tier total (in cents) for a given variant + pack size, from bundle:default tags.
  function tierTotalCentsForUnits(v, units) {
    if (!v) return 0;
    const tierStr = collectDefaultBundleTierStringFromTags(
      productTags,
      v.sku || "",
    );
    let cents = 0;
    tierStr.split("|").forEach(function (seg) {
      const s = String(seg).trim();
      const dash = s.lastIndexOf("-");
      if (dash <= 0) return;
      const q = parseInt(s.slice(0, dash), 10);
      const price = parseFloat(s.slice(dash + 1));
      if (q === units && !isNaN(price)) cents = Math.round(price * 100);
    });
    return cents;
  }

  // "Overstock Luxe Sateen Bamboo vs other brand" comparison rows: keep our price in sync
  // with the selected variant, scale the competitor anchor from it, and follow the size.
  function updateComparisonPricing(v) {
    if (!v) return;
    const container = document.querySelector(".bcl-compare");
    const mult = container
      ? parseFloat(container.getAttribute("data-bcl-them-mult") || "0")
      : 0;
    const sizeVal =
      meta.sizeIdx >= 0 && v.options ? v.options[meta.sizeIdx] : "";
    document.querySelectorAll("[data-bcl-cmp-price]").forEach(function (row) {
      const role = row.getAttribute("data-bcl-cmp-price");
      let units = 1;
      if (role === "bundle3") units = 3;
      else if (role === "bundle6") units = 6;

      let ourCents = v.price;
      if (units > 1) {
        const t = tierTotalCentsForUnits(v, units);
        ourCents = t > 0 ? t : v.price * units;
      }

      const usEl = row.querySelector("[data-bcl-cmp-us]");
      if (usEl) usEl.textContent = formatMoneyCents(ourCents);

      const themEl = row.querySelector("[data-bcl-cmp-them]");
      if (themEl && mult > 0) {
        // Competitor charges per set with no bundle discount; round to the nearest $10.
        const themCents = Math.round((v.price * mult * units) / 1000) * 1000;
        themEl.textContent = formatMoneyCents(themCents) + "+";
      }

      const featEl = row.querySelector(
        "[data-bcl-cmp-feature][data-bcl-cmp-feature-tmpl]",
      );
      if (featEl && sizeVal) {
        const tmpl = featEl.getAttribute("data-bcl-cmp-feature-tmpl") || "";
        featEl.textContent = tmpl.replace("{size}", sizeVal);
      }
    });
  }

  // One entry point for any size/color/bundle change.
  function applySelection() {
    ensureValidColorForCurrentSize();
    updateVariant();
    refreshColorAvailability();
    syncUrlToSelection();
  }

  function matchOptionParam(idx, raw) {
    if (idx < 0 || !raw) return null;
    let found = null;
    product.variants.some(function (v) {
      const val = optAt(v, idx);
      if (val != null && handleizeSize(val) === handleizeSize(raw)) {
        found = val;
        return true;
      }
      return false;
    });
    return found;
  }

  // Resolve the initial size/color from the URL (?variant=, or ?size=/?color=),
  // applying the color-availability fallback before first paint of the selection.
  function resolveInitialSelection() {
    let usp;
    try {
      usp = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }
    let wantSize = null;
    let wantColor = null;

    const vParam = usp.get("variant");
    if (vParam) {
      const vv = product.variants.find(function (v) {
        return String(v.id) === String(vParam);
      });
      if (vv) {
        if (meta.sizeIdx >= 0) wantSize = optAt(vv, meta.sizeIdx);
        if (meta.colorIdx >= 0) wantColor = optAt(vv, meta.colorIdx);
      }
    }
    const sParam = usp.get("size");
    if (sParam) {
      const m = matchOptionParam(meta.sizeIdx, sParam);
      if (m) wantSize = m;
    }
    const cParam = usp.get("color") || usp.get("colour");
    if (cParam) {
      const m = matchOptionParam(meta.colorIdx, cParam);
      if (m) wantColor = m;
    }

    if (wantSize == null && meta.sizeIdx >= 0)
      wantSize = selected[meta.sizeIdx];
    if (wantColor == null && meta.colorIdx >= 0)
      wantColor = selected[meta.colorIdx];

    if (wantSize != null) checkRadioByValue(".bcl-size", wantSize);

    let useColor = wantColor;
    const combo = variantForSizeColor(wantSize, wantColor);
    if (!combo || !combo.available) {
      const fb = firstAvailableColorForSize(wantSize);
      if (fb) useColor = fb;
    }
    if (useColor != null) checkRadioByValue(".bcl-color", useColor);
  }

  // ---- Wire inputs ----
  form.addEventListener("change", (e) => {
    if (
      e.target.matches(
        "[data-bcl-option-index], select[data-bcl-option-index]",
      ) ||
      e.target.matches('input[name="bcl-tag-bundle-tier"]')
    ) {
      applySelection();
    }
  });
  // Click on a bundle/color/size LABEL — the native <input type=radio> handles state, but
  // we also want the visual class update immediately.
  form.addEventListener("click", (e) => {
    const lbl = e.target.closest(".bcl-color, .bcl-size, .bcl-bundle");
    if (!lbl) return;
    // Sold-out sizes are not selectable.
    if (
      lbl.classList.contains("bcl-size") &&
      lbl.classList.contains("is-soldout")
    ) {
      e.preventDefault();
      return;
    }
    const input = lbl.querySelector("input[type=radio]");
    if (!input) return;

    if (
      tagPicker &&
      input.name === "bcl-tag-bundle-tier" &&
      lbl.dataset.bclWillToggleOptOut === "1"
    ) {
      const optOut = tagPicker.querySelector(
        'input[name="bcl-tag-bundle-tier"][value="opt-out"]',
      );
      if (optOut) {
        optOut.checked = true;
        tagPicker
          .querySelectorAll(".bcl-bundle--tag-tier")
          .forEach(function (l) {
            delete l.dataset.bclWillToggleOptOut;
          });
        applySelection();
        return;
      }
    }

    input.checked = true;
    applySelection();
  });

  resolveInitialSelection();

  try {
    const usp = new URLSearchParams(window.location.search);
    const wantBundle = usp.get("bundle");
    if (tagPicker && wantBundle) {
      const want = String(parseInt(wantBundle, 10) || 0);
      if (want && want !== "0") {
        const target = tagPicker.querySelector(
          'input[name="bcl-tag-bundle-tier"][value="' + want + '"]',
        );
        if (target) {
          tagPicker
            .querySelectorAll('input[name="bcl-tag-bundle-tier"]')
            .forEach(function (r) {
              r.checked = false;
            });
          target.checked = true;
          const lbl = target.closest(".bcl-bundle--tag-tier");
          if (lbl) {
            tagPicker
              .querySelectorAll(".bcl-bundle--tag-tier")
              .forEach(function (l) {
                l.classList.remove("is-selected");
              });
            lbl.classList.add("is-selected");
          }
        }
      }
    }
  } catch (e) {}

  refreshSizeAvailability();
  applySelection();
  setTimeout(function () {
    if (typeof jQuery !== "undefined")
      jQuery(document).trigger("bcl:variant-changed");
  }, 400);

  const wishBtn = $("[data-bcl-wishlist]", form.closest(".bcl-hero"));
  if (wishBtn) {
    wishBtn.addEventListener("click", function () {
      const opts = readSelections();
      const v = findVariant(opts);
      window.dispatchEvent(
        new CustomEvent("bcl:wishlist", {
          detail: {
            productId: product.id,
            variantId: v ? v.id : null,
            handle: product.handle,
          },
        }),
      );
      if (
        window._swat &&
        typeof window._swat.addToWishList === "function" &&
        v
      ) {
        try {
          window._swat.addToWishList({
            epi: v.id,
            empi: product.id,
            du: window.location.href,
          });
        } catch (e) {}
      }
    });
  }

  const heroRoot = form.closest(".bcl-hero");
  if (heroRoot) {
    heroRoot.querySelectorAll("[data-bcl-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        const src = t.dataset.src;
        const main = heroRoot.querySelector(".bcl-main-img");
        if (main && src) {
          if (main.tagName === "IMG") {
            main.removeAttribute("srcset");
            main.src = src;
          } else main.style.backgroundImage = "url('" + src + "')";
        }
        heroRoot.querySelectorAll("[data-bcl-thumb]").forEach(function (x) {
          x.classList.remove("is-active");
        });
        t.classList.add("is-active");
      });
    });
  }

  // ---- Live viewers count (slow drift around theme setting) ----
  function initLiveViewersTicker() {
    const el = form.querySelector("[data-bcl-live-viewers]");
    if (!el) return;
    const base = parseInt(
      String(el.getAttribute("data-bcl-live-base") || el.textContent).replace(
        /\D/g,
        "",
      ),
      10,
    );
    if (isNaN(base) || base < 1) return;

    let current = base;
    const spread = Math.max(6, Math.round(base * 0.07));
    const min = Math.max(1, base - spread);
    const max = base + spread;

    function nudge() {
      const step = Math.random() < 0.3 ? 2 : 1;
      const dir = Math.random() < 0.52 ? 1 : -1;
      let next = current + dir * step;
      if (next < min) next = current + step;
      if (next > max) next = current - step;
      next = Math.min(max, Math.max(min, next));
      if (next !== current) {
        current = next;
        el.textContent = String(current);
        el.classList.remove("bcl-live-flash");
        // Force reflow so the animation can replay.
        // eslint-disable-next-line no-unused-expressions
        el.offsetWidth;
        el.classList.add("bcl-live-flash");
      }
    }

    function schedule(initial) {
      // First nudge within ~3–6s so the counter is visibly alive; then 6–14s loops.
      const delay = initial
        ? 3000 + Math.random() * 3000
        : 6000 + Math.random() * 8000;
      window.setTimeout(function () {
        nudge();
        schedule(false);
      }, delay);
    }

    schedule(true);
  }
  initLiveViewersTicker();

  // ---- Sticky bar ----
  const stickyBar = $("[data-bcl-sticky-bar]");
  if (stickyBar) {
    const cta = $("[data-bcl-submit]");
    const onScroll = () => {
      if (!cta) return;
      const rect = cta.getBoundingClientRect();
      const ctaOffscreen = rect.bottom < 0 || rect.top > window.innerHeight;
      stickyBar.dataset.bclVisible = ctaOffscreen ? "true" : "false";
      document.body.classList.toggle("bcl-sticky-active", ctaOffscreen);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  // ---- Scroll-to-form CTAs ----
  $$("[data-bcl-scroll-top]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const target = $("#bcl-product-form");
      if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  // Busy state for the CTA while the add is in flight — spinner + "Adding…"
  // so the user sees something happening.
  function setCtaAdding(on) {
    const btn = form.querySelector("[data-bcl-submit]");
    if (!btn) return;
    const label = form.querySelector("[data-bcl-submit-label]");
    if (on) {
      btn.dataset.bclPrevLabel = label ? label.textContent.trim() : "";
      btn.classList.add("is-adding");
      btn.disabled = true;
      if (label) label.textContent = "Adding…";
    } else {
      btn.classList.remove("is-adding");
      btn.disabled = false;
      if (label && btn.dataset.bclPrevLabel)
        label.textContent = btn.dataset.bclPrevLabel;
      delete btn.dataset.bclPrevLabel;
    }
  }

  // Native POST to cart/add redirects to the cart page; intercept so the theme AJAX + sidecart run once.
  // stopPropagation prevents the delegated sidecart handler from seeing the same submit (avoids double add).
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof jQuery === "undefined") return;
    const busyBtn = form.querySelector("[data-bcl-submit]");
    if (busyBtn && busyBtn.classList.contains("is-adding")) return;
    setCtaAdding(true);
    const $f = jQuery(form);
    jQuery
      .ajax({
        url: "/cart/add.js",
        type: "POST",
        // Pin JSON so jQuery doesn't treat the .js response as a script and
        // eval it (the source of the console "Unexpected token ':'" errors);
        // a bot-challenge/HTML response now cleanly hits .fail instead.
        dataType: "json",
        data: $f.serialize(),
      })
      .done(function () {
        setCtaAdding(false);
        if (jQuery("[data-addon-product-id]").prop("checked")) {
          if (typeof addAddOnProduct === "function") {
            addAddOnProduct(
              jQuery("[data-addon-product-id]").attr("data-addon-product-id"),
            );
          }
        } else {
          if (typeof getCartData === "function") getCartData();
          if (typeof toggleSideCart === "function") toggleSideCart();
        }
      })
      .fail(function (data) {
        setCtaAdding(false);
        if (typeof showFailed === "function") {
          showFailed(
            data,
            $f
              .find(
                '[data-bcl-submit], button[type="submit"], input[type="submit"]',
              )
              .first(),
          );
        }
      });
  });
})();
